import React from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAirConditioningCategory,
  getCarBrand,
  AddAirConditioningServices,
  getAirConditioningListing,
  DeleteAirconditioningService,
  UpdateAirConditioningService,
} from '../../../../Redux/Actions/UserAction';
import Sidebar from '../../../common/Sidebar/Sidebar';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useTranslation } from 'react-i18next';
import { CommonBusinessHeader } from '../CommonBusinessHeader';
import Swal from 'sweetalert2';

const AirConditioningServices = () => {
  const { t, i18n } = useTranslation();
  /* [CF 2026-08-17] Brand chips read `name || nameAr`, which is English-first
     whatever the site language — so an Arabic owner saw NISSAN, CHEVROLET,
     KIA. The brand master carries both spellings for all 108 brands, so it is
     only a matter of picking the one that matches the language. */
  const isRTL = (i18n.language || 'en').toLowerCase().startsWith('ar');
  const brandLabel = (brand) =>
    (isRTL ? brand?.nameAr || brand?.name : brand?.name || brand?.nameAr) || '';
  const dispatch = useDispatch();
  const home = useSelector((state) => state?.home);

  const ServiceList = home?.getCategoryList;
  const CarBrandList = home?.garageCarBrandList;
  const getAirConditioningList = home?.getAirConditioningList;

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: 'all' });

  const [slected, setslected] = useState([{ id: '' }]);

  const [services, setservices] = useState([
    {
      service: '',
      carBrands: [],
    },
  ]);

  useEffect(() => {
    dispatch(getAirConditioningCategory());
    dispatch(getCarBrand());
  }, [dispatch]);

  /* [CF 2026-08-17] Same reload fix as Quick Services: the owner's business id
     is not in sessionStorage yet on a hard refresh — it arrives with
     /business/my a moment later — so fetching once at mount asked for
     `undefined` and the page came up empty. */
  const ownerBid =
    (home?.getMybusiness?.businessId && String(home.getMybusiness.businessId)) ||
    sessionStorage.getItem('BusinessId');

  useEffect(() => {
    if (ownerBid && ownerBid !== 'undefined' && ownerBid !== 'null') {
      dispatch(getAirConditioningListing(ownerBid));
    }
  }, [dispatch, ownerBid]);

  console.log('ServiceList', ServiceList);

  const handleInputAdd = (e, indexValue) => {
    const { name, value } = e.target;
    const list = [...services];
    list[indexValue][name] = value;
    setservices(list);
  };

  const handleAddBrand = (e, i, Value, brandid) => {
    console.log(index1);

    const list = [...services];
    let SELECT_ARR = [...slected, brandid];

    if (list[index1].carBrands.includes(Value)) {
      list[index1].carBrands = list[index1].carBrands.filter(
        (brand) => brand !== Value
      );
    } else {
      list[index1].carBrands = [...services[index1].carBrands, Value];
    }

    if (slected.includes(brandid)) {
      SELECT_ARR = SELECT_ARR.filter((id) => id !== brandid);
    }

    setservices(list);
    setslected(SELECT_ARR);
  };

  const [index1, setIndex] = useState('');

  const handleRemoveClick = (index) => {
    const list = [...services];
    list.splice(index, 1);
    setservices(list);
  };
  const handleAddClick = (e) => {
    setservices([
      ...services,
      {
        service: '',
        carBrands: [],
      },
    ]);
  };

  const onDeleteClickHandler = (item) => {
    // [CF-15] Confirm before deleting (was deleting instantly).
    Swal.fire({
      title: t('Are you sure?'),
      text: t('This item will be permanently deleted.'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d',
      confirmButtonText: t('Yes, delete it'),
      cancelButtonText: t('Cancel'),
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          DeleteAirconditioningService({
            airConditioningServiceId: item?.airConditioningServiceId,
            businessId: item?.businessId,
          })
        );
      }
    });
  };

  const [editFormData, setEditFormData] = useState({
    service: '',
    carBrands: [],
    airConditioningServiceId: '',
  });

  const onEditHandler = (data) => {
    console.log('as8d98asdedit', data);

    const existingBrandIds = data?.brands?.map(
      (brand) => brand?.brand?.brandId
    );
    setEditFormData({
      service: data.serviceId,
      carBrands: existingBrandIds || [],
      airConditioningServiceId: data.airConditioningServiceId,
    });
  };

  // Convert '' values to null so empty-string UUID/FK fields don't break the
  // backend insert.
  const clean = (obj) =>
    Object.fromEntries(
      Object.entries(obj).map(([k, v]) => [k, v === '' ? null : v])
    );

  // Close a Bootstrap modal after a successful save. Tries the Bootstrap 5 API,
  // then jQuery, then a manual DOM teardown so it works regardless of which
  // Bootstrap flavour is loaded.
  const closeModal = (modalId) => {
    const el = document.getElementById(modalId);
    if (!el) return;
    try {
      // eslint-disable-next-line no-undef
      const BS = window.bootstrap;
      if (BS && BS.Modal) {
        const inst = BS.Modal.getInstance(el) || new BS.Modal(el);
        inst.hide();
        return;
      }
    } catch (e) {}
    try {
      if (window.jQuery) {
        window.jQuery(el).modal('hide');
        return;
      }
    } catch (e) {}
    // Manual teardown
    el.classList.remove('show');
    el.style.display = 'none';
    document.body.classList.remove('modal-open');
    document
      .querySelectorAll('.modal-backdrop')
      .forEach((b) => b.parentNode && b.parentNode.removeChild(b));
  };

  const datasubmit = () => {
    var servicesdata = { services: services.map((s) => clean(s)) };

    dispatch(AddAirConditioningServices(servicesdata));
    closeModal('add-car-brands-modal');
  };

  const ResetHendler = () => {};

  const sideBarOpt = [
    {
      icon: 'assets/images/icons/sp-business/manage-business.svg',
      link: '/sp-air-conditioning-business',
      label: t('Manage Business'),
    },
    {
      icon: 'assets/images/icons/sp-business/manage-service.svg',
      link: '/sp-air-conditioning-services',
      label: t('Manage Services'),
    },
    {
      icon: 'assets/images/icons/sp-business/banner.svg',
      link: '/sp-air-conditioning-banner',
      label: t('Banner'),
    },
    {
      icon: 'assets/images/icons/sp-business/manage-working-hours.svg',
      link: '/sp-air-conditioning-working-hours',
      label: t('Manage Working Hours'),
    },
  ];

  const toggleBrandSelection = (brandId) => {
    setEditFormData((prev) => {
      const carBrands = prev.carBrands.includes(brandId)
        ? prev.carBrands.filter((b) => b !== brandId)
        : [...prev.carBrands, brandId];
      return { ...prev, carBrands };
    });
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    console.log('editFormData', editFormData);

    dispatch(
      UpdateAirConditioningService({
        services: [clean(editFormData)],
      })
    );
    closeModal('airconditioning-services-update');
  };

  return (
    <div>
      <CommonBusinessHeader
        dataList={getAirConditioningList}
        getNameKey="airConditioningName"
      />
      <div class="main-content-area">
        <div class="container">
          <div class="row justify-content-between">
            <Sidebar options={sideBarOpt} />

            <div class="col-12 col-sm-12 col-md-9 col-lg-9">
              <form onSubmit={handleSubmit(datasubmit)}>
                <h2 class="mb-4">{t('Manage Services')}</h2>
                <div class="row mb-2">
                  <div class="col-12">
                    <button
                      type="button"
                      id="btnAdd-2"
                      class="btn btn-warning"
                      onClick={handleAddClick}
                    >
                      {t('Add more Services')}
                    </button>
                  </div>
                </div>

                {services.map((x, indexValue) => {
                  return (
                    <div id="example-2">
                      <div class="row group manage-services-row">
                        <div class="col-12 col-sm-12 col-md-4 mb-2 mb-sm-2 mb-md-0">
                          <label for="service-type" class="sr-only">
                            {t('Service Type')}
                          </label>
                          <select
                            class="form-control"
                            name="service"
                            value={x.service}
                            onChange={(e) => handleInputAdd(e, indexValue)}
                          >
                            <option> - Service Type - </option>
                            {ServiceList !== undefined && ServiceList.length
                              ? ServiceList.map((x) => {
                                  // console.log(x);
                                  return (
                                    <option value={x?.serviceId}>
                                      {x?.service}
                                    </option>
                                  );
                                })
                              : ''}
                          </select>
                        </div>

                        <div class="col-12 col-sm-12 col-md-4 mb-2 mb-sm-2 mb-md-0">
                          <a
                            class="btn btn-outline-secondary"
                            href="javascript:void(0);"
                            role="button"
                            data-toggle="modal"
                            data-target="#add-car-brands-modal"
                            onClick={() => {
                              setIndex(indexValue);
                              // setslected([...slected,{id:''}])
                            }}
                          >
                            {t('Add Car Brands')}
                          </a>
                        </div>

                        <div class="col-12 col-sm-12 col-md-4">
                          {services.length !== 1 && (
                            <button
                              type="button"
                              class="btn btn-danger btnRemove"
                              onClick={() => handleRemoveClick(indexValue)}
                            >
                              {t('Remove')}
                            </button>
                          )}
                        </div>
                      </div>
                      <div
                        class="modal fade"
                        id="add-car-brands-modal"
                        tabindex="-1"
                        aria-labelledby="exampleModalLabel"
                        aria-hidden="true"
                      >
                        <div class="modal-dialog modal-dialog-scrollable modal-lg">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title" id="exampleModalLabel">
                                {t('Car Brands')}
                              </h5>
                              <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <div class="add-car-brands-wrap">
                                {/* <ul
                                  class="nav nav-pills mb-3"
                                  id="pills-tab"
                                  role="tablist"
                                >
                                  {CarBrandList !== undefined &&
                                  CarBrandList.length
                                    ? CarBrandList.map((item) => {
                                        return (
                                          <li class="nav-item">
                                            <a class="nav-link ">{item.area}</a>
                                          </li>
                                        );
                                      })
                                    : ''}
                                </ul> */}
                                <div class="tab-content">
                                  <div class="tab-pane fade show active nav-item">
                                    <div class="row ">
                                      {CarBrandList !== undefined &&
                                      CarBrandList.length
                                        ? CarBrandList?.map((item, index) => {
                                            return (
                                              <div class="col-6 col-sm-6 col-md-2 mb-4">
                                                <div
                                                  class="car-brands-block"
                                                  name="carBrands"
                                                  id={indexValue}
                                                  onClick={(e) =>
                                                    handleAddBrand(
                                                      e,
                                                      indexValue,
                                                      item?.brandId,
                                                      item?.brandId
                                                    )
                                                  }
                                                >
                                                  <div
                                                    class="car-brands-a "
                                                    style={{ color: 'yellow' }}
                                                    name="carBrands"
                                                    id={indexValue}
                                                    value={x.carBrands}
                                                  >
                                                    <img
                                                      id={indexValue}
                                                      style={{
                                                        opacity:
                                                          slected.includes(
                                                            item.brandId
                                                          )
                                                            ? '0.1'
                                                            : '',
                                                      }}
                                                      src={item?.media?.path}
                                                      class="img-fluid"
                                                      alt=""
                                                      onError={(e) => {
                                                        e.target.src =
                                                          'assets/images/car-brands/all.jpg';
                                                      }}
                                                    />
                                                  </div>

                                                  <div class="car-brands-b nav-item">
                                                    {/* [CF 2026-08-17] Was `NAME (nameAr)` - both spellings at once. Show the one that matches the site language. */}
                                                    {brandLabel(item)}
                                                  </div>
                                                </div>
                                              </div>
                                            );
                                          })
                                        : ''}
                                      <hr />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="modal-footer">
                              <button
                                type="button"
                                class="btn btn-primary "
                                data-dismiss="modal"
                              >
                                {t('Submit')}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}

                {/* [FB2-#9c] Polished branded cards; inline-flex layout keeps
                    the Edit/Delete buttons clear of the name and chips. */}
                <div className="row" id="service-container">
                  {getAirConditioningList?.[0]?.services?.map((dt, ind) => (
                    <div className="col-12 col-lg-6 mb-3" key={ind}>
                      <div className="qs-svc-card">
                        <span className="qs-svc-accent" aria-hidden="true" />
                        <div
                          style={{ flex: 1, minWidth: 0, padding: '14px 16px' }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'flex-start',
                              justifyContent: 'space-between',
                              gap: '10px',
                            }}
                          >
                            <div
                              style={{
                                fontWeight: 700,
                                fontSize: '1.02rem',
                                color: '#1d2229',
                                minWidth: 0,
                                overflowWrap: 'anywhere',
                              }}
                            >
                              {dt?.service}
                            </div>
                            <div
                              style={{
                                display: 'flex',
                                gap: '8px',
                                flexShrink: 0,
                              }}
                            >
                              <button
                                type="button"
                                className="qs-icon-btn qs-icon-edit"
                                title={t('Edit')}
                                aria-label={t('Edit')}
                                onClick={() => onEditHandler(dt)}
                                data-toggle="modal"
                                data-target="#airconditioning-services-update"
                              >
                                <i className="far fa-edit"></i>
                              </button>
                              <button
                                type="button"
                                className="qs-icon-btn qs-icon-del"
                                title={t('Delete')}
                                aria-label={t('Delete')}
                                onClick={() => onDeleteClickHandler(dt)}
                              >
                                <i className="far fa-trash-alt"></i>
                              </button>
                            </div>
                          </div>
                          {dt?.brands?.length > 0 && (
                            <>
                              <div
                                style={{
                                  display: 'flex',
                                  flexWrap: 'wrap',
                                  gap: '6px',
                                }}
                              >
                                {dt?.brands?.map((bd, inde) => (
                                  <span className="qs-chip" key={inde}>
                                    {brandLabel(bd?.brand)}
                                  </span>
                                ))}
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <div
                  className="modal fade"
                  id="airconditioning-services-update"
                  tabIndex="-1"
                  aria-labelledby="editServiceModalLabel"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title" id="editServiceModalLabel">
                          {t('Edit Service')}
                        </h5>
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <form>
                          <div className="form-group">
                            <label htmlFor="editServiceType">
                              {t('Service Type')}
                            </label>
                            <select
                              className="form-control"
                              id="editServiceType"
                              value={editFormData.service}
                              onChange={(e) =>
                                setEditFormData({
                                  ...editFormData,
                                  service: e.target.value,
                                })
                              }
                            >
                              <option> - Select Service Type - </option>
                              {ServiceList?.map((x) => (
                                <option value={x?.serviceId}>
                                  {x?.service}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="form-group">
                            <label>{t('Car Brands')}</label>
                            <div className="row">
                              {CarBrandList?.map((brand) => (
                                <div
                                  className="col-md-2 text-center mb-3"
                                  key={brand.brandId}
                                >
                                  <img
                                    src={brand.media?.path}
                                    className="img-fluid"
                                    style={{
                                      opacity: editFormData?.carBrands.includes(
                                        brand.brandId
                                      )
                                        ? 1
                                        : 0.3,
                                      cursor: 'pointer',
                                    }}
                                    onClick={() =>
                                      toggleBrandSelection(brand.brandId)
                                    }
                                    onError={(e) =>
                                      (e.target.src =
                                        'assets/images/car-brands/all.jpg')
                                    }
                                    alt=""
                                  />
                                  <p style={{ fontSize: '0.8rem' }}>
                                    {brandLabel(brand)}
                                  </p>
                                </div>
                              ))}
                            </div>
                          </div>

                          <button
                            onClick={handleEditSubmit}
                            className="btn btn-primary"
                          >
                            {t('Update')}
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mt-5 ">
                  {/* <div class="col-6">
                    <button
                      type="reset"
                      onClick={ResetHendler}
                      class="btn btn-secondary btn-block"
                      href="#"
                      // onClick={ResetHendler}
                      // role='button'
                    >
                      {t('Reset')}
                    </button>
                  </div> */}
                  <div class="col-6">
                    <button
                      type="submit"
                      // to='/sp-garages-packages'
                      class="btn btn-warning btn-block"
                      // href='sp-garages-manage-business-packages.html'
                      // role='button'
                    >
                      {t('Submit')}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AirConditioningServices;
